import {
  Middleware,
  type UnknownAction,
  isRejectedWithValue,
} from '@reduxjs/toolkit';
import {
  setAuthenticated,
  setRedirectUrl,
} from 'store/features/user/auth-slice';
import { baseApi } from './base-api';
import { PUBLIC_ENDPOINTS } from './constants';

type RejectedAuthAction = UnknownAction & {
  payload?: { status?: number };
  meta?: { arg?: { endpointName?: string } };
};

export const authErrorMiddleware: Middleware =
  ({ dispatch }) =>
  (next) =>
  (action: unknown) => {
    if (
      isRejectedWithValue(action) &&
      (action as RejectedAuthAction).payload?.status === 401
    ) {
      const endpointName = (action as RejectedAuthAction).meta?.arg
        ?.endpointName;

      const isPublicEndpoint =
        typeof endpointName === 'string' && PUBLIC_ENDPOINTS.has(endpointName);

      if (!isPublicEndpoint) {
        dispatch(setAuthenticated(false));

        const currentPath = window.location.pathname + window.location.search;
        dispatch(setRedirectUrl(currentPath));

        if (endpointName !== 'getUserData') {
          dispatch(baseApi.util.resetApiState());
        }
      }
    }

    return next(action);
  };
